export const REFRESH_TOKEN = '/refresh';

export const USER = '/user/';
export const USERS = '/users/';
export const EMPLOYEES = '/employees/';
export const AUTH = `${USER}auth/`;
export const TRANSACTION = '/transaction/';
export const MY_ACCOUNTS = `${TRANSACTION}my-accounts/`;
export const FORGOT_PASSWORD = `${AUTH}forgot-password/`;
const NOTIFICATIONS = '/app-notifications';
export const INVESTORS = '/investors/';
export const INVESTMENTS = '/investments';
export const INSTRUMENTS = '/instruments';
export const CLAIMS = '/claims';
export const ACCOUNT_FUNDS = '/instruments/current-investor-account';
export const COUNTRIES = '/enums/countries';
export const FUNDS_LIST = '/instruments/self-directed';
export const INSTRUMENTS_CATEGORIES = `${INSTRUMENTS}/categories`;
export const INVESTMENT_PERFORMANCE_LIST = '/performance-histories';
export const INVESTMENT_SCHEDULERS = '/investment-schedulers';
export const INVESTMENT_TRADING_SUMMARY = '/trades/amounts';
export const INVESTMENTS_FLOW_APPROVE = '/investments/flows/approve';
export const INVESTMENTS_FLOW_QUESTIONNAIRE = '/investments/flows/questionnaire';
export const INVESTMENTS_GET_PNL = '/investors/performance/pnl';
export const INVESTMENTS_PORTFOLIOS = '/investment-portfolios/proposed';
export const INVESTMENTS_UPDATE_RISK_MODEL = (id?: string) => `${INVESTORS}${id}/risk-tolerance-model`;
export const MONEY_TRANSFER = '/money-transfers';
export const ORDERS = '/orders';
const CIP_PREFIX = '/cip';
const CARD_PURSES = '/card-purses';
const IDOLOGY_PREFIX = '/idology';
const UI = '/ui';
const DOCUMENTS = '/documents';
const SPEND_LIMIT_PERIODS = '/spend-limit-periods';
const PLAN_YEARS = '/plan-years';
const HEALTH_PLANS = '/health-plans';

const DEPENDENTS_V2 = `/v2/dependents`;
/**
 * @deprecated Use `import {API_URL} from '@/dtos'` instead. This will be removed soon.
 */
export default {
  ACCOUNT_ACTIVITIES_BY_ID: (accountId: string) =>
    `/v2/activities/accounts/${accountId}`,
  GET_TRANSACTION_TYPES_BY_ACCOUNT_ID: (accountId?: string) =>
    `/activities/accounts/${accountId}/transaction-types`,
  ACTIVITY_DETAILS_EXPENSES: '/statistics/expenses',
  ACTIVITY_DETAILS: '/activities',
  ACTIVITY_POSTINGS_BY_ID: (postingId: string) => `/activities/postings/${postingId}`,
  ACTIVITY_CLAIMS_BY_ID: (claimId: string) => `/activities/claims/${claimId}`,
  ACCOUNT_ORDERS: '/account-orders',
  ACCOUNT_NUMBER: (accountId: string) => `/accounts/hsa/${accountId}/number`,
  ADD_VAULTED_ACCOUNT_TO_RECIPIENT: (merchantCustomerId?: string) =>
    `/recipients/${merchantCustomerId}/accounts`,
  ADD_PROVIDER: '/providers',
  UPDATE_PROVIDER: (id?: string) => `/providers/${id}`,
  BANC_ACCOUNT: '/accounts',
  BANC_ACCOUNT_BY_ID: (accountId: string | number) => `/accounts/${accountId}`,
  CARD_ADD_DEPENDENT: '/card-add-dependent/',
  CARD_HOLDERS_MOCK: '/card-holders',
  CARD_HOLDERS: (query: string) => `/card-holders?${query}`,
  CARD_TRANSACTIONS: `${TRANSACTION}card/`,
  CARD_ACTIVITY: '/activities/cards',
  CARDS: 'cards',
  CARD_PURSES,

  COUNTRIES,
  INVESTMENT_SCHEDULERS,
  FUNDS_LIST,
  INSTRUMENTS_CATEGORIES,
  CIP_INFO: '/cip-infos/employee-id',
  CIP_CHALLENGE: `${IDOLOGY_PREFIX}/challenge`,
  CIP_CHALLENGE_ANSWERS: `${IDOLOGY_PREFIX}/challenge-answers`,
  CIP_ANSWERS: `${CIP_PREFIX}/challenge-answers`,
  CIP_IDENTIFICATION: `${IDOLOGY_PREFIX}/identification`,
  CIP_QUESTIONS: `${CIP_PREFIX}/questions`,
  CIP_QUESTIONS_ANSWERS: `${IDOLOGY_PREFIX}/questionnaire-answers`,
  CIP_STATUS: '/cip-statuses',
  CLAIM_STATUSES: '/enums/claim-status',
  GET_BENEFICIARIES: (employeeId?: string) => `${EMPLOYEES}${employeeId}/beneficiaries`,
  CREATE_BENEFICIARIES: (employeeId?: string) => `${EMPLOYEES}${employeeId}/beneficiaries`,
  UPDATE_BENEFICIARIES: (employeeId?: string) => `${EMPLOYEES}${employeeId}/beneficiaries`,
  DELETE_BENEFICIARIES: (employeeId?: string) => `${EMPLOYEES}${employeeId}/beneficiaries`,
  GET_BENEFICIARY_TYPES: '/enums/beneficiary-relationship-types',
  GET_CHECKS_LIST: '/checks/search',
  REISSUE_CHECK: (id?: string) => `/checks/${id}/reissue`,
  VOID_CHECK: (id?: string) => `/checks/${id}/void`,
  CLAIMS_ACTIVITIES: `${CLAIMS}/search/activities`,
  PROCESS_WAITING_FOR_FUNDS_CLAIM: (id?: string) => `${CLAIMS}/${id}/process-waiting-for-funds`,
  CREATE_CLAIM: CLAIMS,
  CLAIMS_SEARCH_PARTICIPANT: `${CLAIMS}/search/participant`,
  EMPLOYEE_PROCESS: (claimId: string) => `${CLAIMS}/${claimId}/employee-process`,
  CREATE_DOCUMENT_ID: '/documents',
  DEDUCTIBLES_SERVICES: '/deductibles-services',

  CREATE_EXCESS_CONTRIBUTION: '/tax-forms/excess-contributions',
  GET_EXCESS_CONTRIBUTION_BY_ID: (id?: string) => `/tax-forms/excess-contributions/${id}`,

  CREATE_DEPENDENT: DEPENDENTS_V2,
  DEACTIVATE_DEPENDENT: (dependentId?: string) => `${DEPENDENTS_V2}/${dependentId}/deactivate`,
  ACTIVATE_DEPENDENT: (dependentId?: string) => `${DEPENDENTS_V2}/${dependentId}/reactivate`,
  UPDATE_DEPENDENT: (dependentId?: string) => `${DEPENDENTS_V2}/${dependentId}`,
  ADD_CARD_FOR_DEPENDENT: (dependentId?: string) => `${DEPENDENTS_V2}/${dependentId}/add-card`,
  GET_DEPENDENTS_BY_EMPLOYEE_ID: (employeeId?: string | number) => `${DEPENDENTS_V2}/employee/${employeeId}`,

  DEDUCTIBLES: '/tiers/deductibles',
  DELETE_DOCUMENT: (id: string) => `/documents/${id}`,
  DOCUMENT_FILES: '/documents/files',
  DELETE_FILE: (id: string) => `/documents/files/${id}`,
  EXPENSES_STATISTICS: '/expenses/statistics',
  EXPENSES: '/expenses',
  FORGOT_PASSWORD,
  CHANGE_PASSWORD: '/passwords',
  RESET_PASSWORD: 'passwords/reset',
  FORGOT_USERNAME: 'persons/usernames/forgot',
  RESEND_CONFIRMATION_CODE: 'resend-confirmation-code',
  GET_CARD: (cardId: string) => `/cards/${cardId}`,
  VERIFY_CARD: (last4: string) => `cards/verify?last4=${last4}`,
  GET_FILES_BY_DOCUMENT_ID: (documentId?: string) => `/documents/${documentId}/files`,
  GET_PROVIDER: (id: string) => `/providers/${id}`,
  GET_PROVIDERS: '/providers',
  GET_RELATIONSHIP_TYPES: '/enums/relationship-types',
  GET_STATE: (name: string) => `/enums/states&name=${name}`,
  GET_ORGANIZATION_LOCK_STATUS: (id?: string) => `/organization-locks/${id}`,
  INVESTMENT_ACTIVITY_LIST: '/investments-activity',
  INVESTMENT_LIST: '/investments',
  INVESTMENT_PERFORMANCE_LIST,
  INVESTMENT_TRADING_SUMMARY,
  MY_ACCOUNTS,
  MY_ENROLLMENT: '/enrollments',
  REFRESH_TOKEN,
  REIMBURSE_RECEIPT_UPLOAD: (documentId: string) => `/documents/${documentId}/import`,
  REIMBURSE_RECEIPT_UPLOAD_BY_QR: (documentId: string | number) =>
    `/documents/${documentId}/files/by-qr-codes/import`,
  REIMBURSE_SCANNED_FILE: (fileId: string) => `/documents/files/${fileId}/ocr-reader`,
  CLAIM_SCANNED_FILE: (fileId: string) => `/documents/files/${fileId}/openai/ocr/matching`,
  REPLACEMENT_CARD_REQUEST: (cardId: string) => `/cards/${cardId}/replacement`,
  RELATIONSHIPS_TYPES: '/enums/relationship-types',
  SEND_CODE: `${FORGOT_PASSWORD}code`,
  SERVICES: '/services',
  GET_SERVICES_BY_ID: (serviceId?: string) => `/services/${serviceId}`,
  ACCOUNT_ORDERS_SERVICES: '/account-orders/services',
  ACCOUNT_ORDERS_MATRIXES: '/account-orders/matrixes',
  SERVICE_CATEGORIES: '/enums/service-categories',
  SET_CARD_STATUS: (cardId: string) => `/cards/${cardId}`,
  SIGN_UP_BY_GUI: (gui: string) => `${USERS}signup/${gui}`,
  SIGN_UP_BY_SSN: `${USERS}signup`,
  SIGN_UP: '/signup',
  SIGN_UP_COMMUNICATION: `${AUTH}step_3`,
  SIGN_UP_PERSONAL_INFO: `${AUTH}step_1`,
  SIGN_UP_SECURITY_FITST: `${AUTH}step_2_1`,
  SIGN_UP_SECURITY_SECOND: `${AUTH}step_2_2`,
  SIGN_UP_CONFIRMATION: 'sign-up/confirmation',
  SIGNIN: `${AUTH}login`,
  SIGN_IN: 'signin',
  SEND_FORGOT_PASSWORD_CODE: '/forgot-password',
  SERVICE_CONFIGS: '/service-configs',
  REVOKE: '/revoke',

  REGISTRATION_VERIFICATION: 'registration/verification',
  CONFIRM_EMAIL: 'emails/confirmation',
  STATES: '/enums/states',
  TRANSACTION_LIST: `${TRANSACTION}list/`,
  TRANSACTION,
  TRANSACTOR_DETAILS_BY_ID: (id?: string) => `/providers/${id}`,
  NOTIFICATIONS,
  NOTIFICATIONS_DISMISSED: `${NOTIFICATIONS}/dismissed`,
  NOTIFICATIONS_READ: `${NOTIFICATIONS}/read`,
  NOTIFICATIONS_SENT: `${NOTIFICATIONS}/sent`,
  NOTIFICATIONS_STREAM: `${NOTIFICATIONS}/stream`,
  INVESTORS,
  INVESTMENTS_GET_PNL,
  INVESTMENTS_CHANGE_MODEL: `${INVESTORS}investment-models/`,
  INVESTMENT_STOCKS_LIST: '/investment-stocks',
  INVESTMENTS_BUY: `${INVESTMENTS}/buy`,
  INVESTMENTS_SELL: `${INVESTMENTS}/sell`,
  INVESTMENTS_HOLDINGS: `${INVESTMENTS}/holdings`,
  INVESTMENTS_ACTIVITES_PENDING: `${INVESTMENTS}/activities/pending`,
  TRADES: '/trades',
  DOCUMENTS,

  START_CLAIM_REPAYMENT: (claimId?: string) => `${CLAIMS}/${claimId}/start-repayment`,
  CIP_DOCUMENT_SCAN_CHECK: () => '/idology/document-process-status',
  INVESTMENTS_UPDATE_RISK_MODEL,
  INVESTMENTS_PORTFOLIOS,
  INVESTMENTS_ACTIVITIES: '/investments/activities/completed',
  EMPLOYEE_INFO: (employeeId?: string) => `/employees/${employeeId}/employee-view`,
  EMPLOYEE_SSO_SIGNUP: (employeeId?: string) => `/employees/${employeeId}/sso-signup`,
  ORGANIZATION_INFO: (organizationId?: string) => `/organizations/${organizationId}/employee-view`,
  TERMINATE_ORGANIZATION: (id: string) => `/organizations/${id}/termination`,
  EMPLOYER_TERMINATION_PLANS: (orgId: string) => `/plans/organizations/${orgId}/active-grace-period`,
  UPDATE_CLAIM_DOCUMENT_ID: (id?: string) => `${CLAIMS}/${id}/document`,
  UPDATE_CLAIM_DOCUMENT_ID_BY_HASH_ID: (claimId?: string, hashId?: string) =>
    `${CLAIMS}/${claimId}/documents/one-time-links/${hashId}`,
  CLAIMS_PAYMENT_DETAILS: `${CLAIMS}/payment-details`,
  PAYMENT_METHODS: '/payment-methods',
  PROCESSING_RULE_BY_ID: (id?: string) => `/processing-rules/${id}`,
  PLAID_PAYMENT_ACCOUNT: '/payment-account',
  CREATE_DEBIT_CARD_PAYMENT_METHOD: '/payment-methods/debit-card',
  UPDATE_DEFAULT_PAYMENT_METHODS: (paymentMethodId?: number | string) =>
    `/payment-methods/${paymentMethodId}`,
  FISERV_TOKEN: '/tokens',
  ACCOUNT_TOKEN: '/account-tokens',
  FISERV_CARD_ACTIVATION: '/maintenance/card',
  EMPLOYEES_PERSONAL_INFO_BY_ID: (employeeId: number) => `${EMPLOYEES}/personal-info/${employeeId}`,
  CLAIM_CONFIG: (employeeId: string) => `${EMPLOYEES}/${employeeId}/claim-config`,
  ENCRYPTION_PUBLIC_KEY: 'encryption/public-key',
  EMPLOYEE_BY_ID: (id: string | number) => `${UI}/employees/${id}`,
  UI_EMPLOYEE: `${UI}/employees`,
  GET_ACCOUNTS_WITH_VERIFICATION_STATUS: '/accounts/verification',
  GET_STATEMENTS: '/statements',
  GET_TAX_FORMS: '/v2/tax-forms',
  GET_TAX_FORMS_BANNER: '/tax-forms/tax-form-banner',
  GET_TAX_FORMS_BANNER_DISMISS: '/tax-forms/tax-form-banner/disable',
  GET_TAX_FORM_1099_FILE: (id: string) => `/tax-forms/tax-form-1099/${id}/download`,
  GET_TAX_FORM_5498_FILE: (id: string) => `/tax-forms/tax-form-5498/${id}/download`,
  GET_LINKED_ACCOUNTS: `${EMPLOYEES}linked-accounts`,
  IRS_MAXIMUMS: '/irs-maximums',
  CREATE_CONTRIBUTION: '/contributions/contribution-requests/employee',
  CREATE_RECURRING_CONTRIBUTION: '/recurring-contributions',
  UPDATE_RECURRING_CONTRIBUTION: (id?: number) => `/recurring-contributions/${id}`,
  ADD_RECURRING_CONTRIBUTION: '/recurring-contributions/info',
  GET_RECEIPT_QR_CODE: `${DOCUMENTS}/receipts/qr-codes`,
  GET_BALANCE_REMINDER: '/employees/balance-reminder',
  CONTRIBUTION_HISTORY: '/monitor-contribution/info',
  GET_IRS_LIMITS: '/contribution-requests/irs-limits/search',
  CREATE_DOCUMENT_BY_QR_CODE: `${DOCUMENTS}/receipts/by-qr-codes`,
  GET_DOCUMENT_BY_QR_CODE: `${DOCUMENTS}/receipts/file/by-qr-codes/stream`,
  GET_ONE_TIME_LINK_BY_HASH_ID: (hashId: string) => `${DOCUMENTS}/one-time-links/${hashId}`,
  CREATE_DOCUMENT_BY_ONE_TIME_LINK: `${DOCUMENTS}/receipts/by-link`,
  IMPORT_FILE_BY_ONE_TIME_LINK: (documentId: string) => `${DOCUMENTS}/${documentId}/files/by-link/import`,
  GET_CLAIM_SCANNED_FILE_BY_HASH_ID: (fileId: string) =>
    `${DOCUMENTS}/files/by-link/${fileId}/openai/ocr/matching`,
  DEACTIVATE_ONE_TIME_LINK: (hashId?: string) => `${DOCUMENTS}/one-time-links/${hashId}/deactivation`,
  GET_PARTNER_APP_LINKS_BY_QR_CODE: (qrHashId: string) =>
    `/organizations/overridable-properties/by-qr-codes/${qrHashId}`,
  GET_PARTNER_APP_LINKS_BY_HASH_ID: (qrHashId?: string) => `/organization-properties/hash/${qrHashId}`,
  SEND_VERIFICATION_CODE: '/codes/verifications',
  EMAIL_VERIFICATION: '/push-provision/email-validation',
  SPEND_LIMIT_PERIODS: (id?: string) => `${SPEND_LIMIT_PERIODS}/${id}`,
  SPEND_LIMIT_PERIODS_REMAINING: (id?: string) => `${SPEND_LIMIT_PERIODS}/${id}/remaining`,
  VALIDATE_VERIFY_CODE: '/codes/verifications/validation',
  SEND_MFA_CODE: 'mfa/codes',
  VERIFY_MFA_CODE: '/mfa/codes/verifications',
  RETRY_PAYMENT: '/claims/retry-payment',
  GET_REJECTED_CLAIM: (claimId?: string) => `${CLAIMS}/${claimId}/rejected-claim`,
  HEALTH_PLAN_YEARS: `${PLAN_YEARS}${HEALTH_PLANS}`,
  HEALTH_PLAN_BY_ID: (id: string) => `${HEALTH_PLANS}/${id}`,

  INVESTMENTS_FLOW_QUESTIONNAIRE,
  INVESTMENTS_FLOW_APPROVE,
  INVESTMENTS_FLOW_FUNDING: '/investments/flows/funding',
  INVESTMENTS_FLOW_PATH: '/investments/flows/path',
  INVESTMENTS_FLOW_START: '/investments/flows/start',

  ORDERS,
  MONEY_TRANSFER,
  ACCOUNT_FUNDS,

  GET_PLAID_LINK_TOKEN: '/plaid/link-token',
  EXCHANGE_PUBLIC_PLAID_TOKEN: '/plaid/exchange-token',
  ACTIVATE_PLAID_BANK_ACCOUNT: '/bank-accounts/verification-status',
  STATISTIC_CIP_CONFIG: '/metrics/cip-config',
  CARD_SHIPMENT_BY_ID: (id: string) => `/cards/${id}/shipment-events`,

  LETTERS_OF_MEDICAL_NECESSITY: '/letters-of-medical-necessity',
  RECEIPTS: '/documents/receipts/files',

  CREATE_FILE_UPLOAD_URL: (documentId: string) => `/documents/${documentId}/files/link`,
  COMPLETE_FILE_UPLOAD: (documentId: string) => `/documents/${documentId}/files/link/complete`,
  CREATE_FILE_UPLOAD_URL_BY_LINK: (documentId: string) => `/documents/${documentId}/files/by-link/link`,
  COMPLETE_FILE_UPLOAD_BY_LINK: (documentId: string) =>
    `/documents/${documentId}/files/by-link/link/complete`,
  CREATE_FILE_UPLOAD_URL_BY_QR_CODE: (documentId: string) =>
    `/documents/${documentId}/files/by-qr-codes/link`,
  COMPLETE_FILE_UPLOAD_BY_QR_CODE: (documentId: string) =>
    `/documents/${documentId}/files/by-qr-codes/link/complete`,
  LETTERS_OF_MEDICAL_NECESSITY_BY_ID: (id?: string) => `/letters-of-medical-necessity/${id}`,
  CREATE_LETTERS_OF_MEDICAL_NECESSITY: '/letters-of-medical-necessity',
};
